import Model from '../models'
import API from '../../api'
import { getLocalCartId } from 'shared/utils/cart'

Model.ProductGroup.actions.fetchAllOnPage = function () {
  let id
  let products = document.getElementsByClassName('booqable-product')
  const productIds = []

  for (const node of Array.from(products)) {
    // Get product group id
    ({ id } = node.dataset)
    productIds.push(id)
  }

  products = document.getElementsByClassName('booqable-product-button')

  for (const node of Array.from(products)) {
    // Get product group id
    ({ id } = node.dataset)
    productIds.push(id)
  }

  products = document.getElementsByClassName('booqable-product-detail')

  for (const node of Array.from(products)) {
    // Get product group id
    ({ id } = node.dataset)
    productIds.push(id)
  }

  const cartId = getLocalCartId()

  return Model.ProductGroup.actions.fetchAll({ ids: productIds, cart_id: cartId })
}

Model.ProductGroup.createAction('FETCH_ALL', (options) => {
  if (options == null) {
    options = {}
  }

  return API.post('product_groups', options)
})

Model.ProductGroup.createAction('FETCH_SERVICES', (options) => {
  return API.post('product_groups/services', { ...options, apiVersion: 1 })
})

export default Model.ProductGroup.actions
